<template>
  <div class="public-item">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.public-item {
  width: 100%;
  height: 32%;
  display: flex;
  flex-direction: column;
  background-color: rgba(81, 93, 97, 0.219);
  background-size: 100% 100%;
}
</style>